import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const AdvancedEcommerceTemplate = ({
  height = 80,
  width = 72,
  color = colors.white,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} {...props}>
    <rect width="71.1111" height="80" rx="4" fill={getColor(color, isColorInherited)} />
    <rect x="7.11108" y="24" width="25.7778" height="14.2222" rx="2" fill="#E0DEDF" />
    <rect x="38.2222" y="24" width="25.7778" height="14.2222" rx="2" fill="#E0DEDF" />
    <line
      x1="8.11108"
      y1="9.66675"
      x2="63"
      y2="9.66675"
      stroke="#E0DEDF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="8.11108"
      y1="16.7778"
      x2="63"
      y2="16.7778"
      stroke="#E0DEDF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="8.11108"
      y1="44.3333"
      x2="31.8889"
      y2="44.3333"
      stroke="#E0DEDF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="39.2222"
      y1="44.3333"
      x2="62.9999"
      y2="44.3333"
      stroke="#E0DEDF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <rect x="7.11108" y="50.6667" width="25.7778" height="14.2222" rx="2" fill="#E0DEDF" />
    <rect x="38.2222" y="50.6667" width="25.7778" height="14.2222" rx="2" fill="#E0DEDF" />
    <line
      x1="8.11108"
      y1="71"
      x2="31.8889"
      y2="71"
      stroke="#E0DEDF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="39.2222"
      y1="71"
      x2="62.9999"
      y2="71"
      stroke="#E0DEDF"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </SvgIcon>
);
